import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { LocationNodes } from 'modules/locations/hooks/useLocations'

const locationFilter = (
  source: ReturnType<typeof useDocumentsDataTable>,
  locations: LocationNodes
) => {
  const options = locations.map((location) => {
    return {
      value: location.id,
      label: location.name,
    }
  })

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'location_id',
    path: 'location',
    title: i18n.t('documents.employee.filters.location'),
  })
}

export default locationFilter
